/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { formsUpdate } from '../../axios/formsUpdate'
import type {
	FormsUpdateError,
	FormsUpdatePathParams,
	FormsUpdateRequest,
	FormsUpdateResponse,
} from '../../types/FormsUpdate'

export const formsUpdateMutationKey = () => [{ url: '/forms/:form' }] as const

export type FormsUpdateMutationKey = ReturnType<typeof formsUpdateMutationKey>

export type FormsUpdateVariables = {
	form: FormsUpdatePathParams['form']
	data: FormsUpdateRequest
}

/** @see backend/nexus/modules/Form/Http/Controllers/FormController.php FormController::update */
export function useFormsUpdate<TContext = unknown>(
	options?: UseMutationOptions<FormsUpdateResponse, AxiosError<FormsUpdateError>, FormsUpdateVariables, TContext>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: formsUpdateMutationKey(),
		mutationFn: ({ form, data }: FormsUpdateVariables) => formsUpdate(form, data, config).then(res => res.data),
		...options,
	})
}
